import { useEffect, useState } from 'react'

import { PlanningRunListResponse } from '@/entities/schedules/models/planning/PlanningShift'
import { RunsheetRunListResponse } from '@/entities/schedules/models/runsheet/RunsheetShift'
import { OLMSApiService } from '@/shared/apis'
import { useAppSelector } from '@/shared/store'
import { EntityId } from '@reduxjs/toolkit'

export const useFetchScheduleRuns = (scheduleId: EntityId) => {
  const [data, setData] = useState<PlanningRunListResponse[] | RunsheetRunListResponse[]>([])
  const currentScreen = useAppSelector(state => state.userInterface.currentScreen)

  useEffect(() => {
    if (currentScreen === 'planning') {
      OLMSApiService.get<PlanningRunListResponse[]>(`/planning/runList/${scheduleId}/`)
        .then((res) => setData(res || []))

      return
    }

    OLMSApiService.get<RunsheetRunListResponse[]>(`/runsheet/runList/${scheduleId}/`)
      .then((res) => setData(res || []))
  }, [currentScreen, scheduleId])

  return { data }
}